// src/pages/distributor/Distributor.jsx

import React, { useState } from "react";
import styled from "styled-components";
import { Button, Input, Select, Table, TH, TD } from "../../ui";
import { searchDistributorProducts } from "../../services/distributorApi";

const Container = styled.div`
  padding: 2rem;
`;

const Form = styled.form`
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
`;

const Alert = styled.div`
  margin-top: 20px;
  padding: 10px;
  border: 1px solid red;
  border-radius: 8px;
  color: red;
  font-weight: bold;
`;

const STATUS_COLOR = {
  available: "green",
  new: "purple",
  out_of_stock: "red",
  end_of_series: "red",
  coming: "blue",
  restocking: "blue",
  pre_order: "orange",
};


export default function Distributor() {
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("");
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [noResultMessage, setNoResultMessage] = useState("");
  const [webSearchUrl, setWebSearchUrl] = useState("");

  // On n'appelle plus fetchResults() automatiquement ici
  // useEffect(() => {
  //   fetchResults();
  // }, []);

  const fetchResults = async () => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await searchDistributorProducts(searchTerm);

      if (!data.results) {
        throw new Error(data.error || "Erreur lors de la récupération des données");
      }

      if (data.results.length === 0) {
        setResults([]);
        setNoResultMessage("Aucun produit trouvé dans la base de données.");
        setWebSearchUrl(
          data.web_search_url_1 ||
            "https://www.google.com/search?q=distributeurs+jeux+de+société"
        );
      } else {
        setResults(data.results);
        setNoResultMessage("");
        setWebSearchUrl("");
      }
    } catch (err) {
      setError(err.message || "Erreur inconnue");
    }

    setLoading(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchResults();
  };

  return (
    <Container>
      <h1>Catalogue des distributeurs</h1>

      <Form onSubmit={handleSubmit}>
        <label htmlFor="query_dis">Recherche :</label>
        <Input
          type="text"
          id="query_dis"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />

        <label htmlFor="status">Filtrer par statut :</label>
        <Select id="status" value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">Tous</option>
          <optgroup label="Disponibilité immédiate">
            <option value="available">Disponible</option>
            <option value="new">Nouveau</option>
          </optgroup>
          <optgroup label="Ruptures ou fin de commercialisation">
            <option value="out_of_stock">Rupture de stock</option>
            <option value="end_of_series">Fin de série</option>
          </optgroup>
          <optgroup label="À venir ou en réapprovisionnement">
            <option value="coming">À venir</option>
            <option value="restocking">Réapprovisionnement</option>
            <option value="pre_order">Précommande</option>
          </optgroup>
        </Select>

        <Button type="submit" disabled={loading}>
          {loading ? "Recherche..." : "Rechercher"}
        </Button>
      </Form>

      {error && <Alert>{error}</Alert>}

      {noResultMessage && <p>{noResultMessage}</p>}

      {results && results.length > 0 && (
        <Table>
          <thead>
            <tr>
              <TH>Distributeur</TH>
              <TH>Référence</TH>
              <TH>EAN</TH>
              <TH>Désignation</TH>
              <TH>Status</TH>
              <TH>Mini Packaging</TH>
              <TH>Classic Packaging</TH>
            </tr>
          </thead>
          <tbody>
            {results.map((item) => (
              <tr key={item.uuid}>
                <TD>
                  {item.url ? (
                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                      {item.distributor || "—"}
                    </a>
                  ) : (
                    item.distributor || "—"
                  )}
                </TD>
                <TD>{item.reference || "—"}</TD>
                <TD>{item.ean || "—"}</TD>
                <TD>{item.designation || "—"}</TD>
                <TD style={{ color: STATUS_COLOR[item.status] || "inherit" }}>
                  {item.status || "—"}
                </TD>
                <TD>{item.mini_packaging || "—"}</TD>
                <TD>{item.classic_packaging || "—"}</TD>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {results && results.length === 0 && webSearchUrl && (
        <p>
          Vous pouvez aussi essayer une recherche web&nbsp;:{" "}
          <a href={webSearchUrl} target="_blank" rel="noopener noreferrer">
            {webSearchUrl}
          </a>
        </p>
      )}
    </Container>
  );
}
